import React from "react";
import PropTypes from "prop-types";
import BaseGameActionButton from "../../../../components/GameActionButtons";
import useCurrentLocation from "../../../../hooks/useCurrentLocation";
import models from "../../../../types/models";
import "./style.scss";
import { observer } from "mobx-react-lite";

export default observer(function SwiperActions({
  countCard,
  isSwiping,
  isToRight,
  isNegative,
  isNeutral,
  isToTop,
  isToLeft,
  isPositive,
  backSwipe,
  positiveSwipe,
  neutralSwipe,
  negativeSwipe,
  isAnsweredCardsExist,
  forwardSwipe,
  card,
  completedCards,
}) {
  SwiperActions.propTypes = {
    countCard: PropTypes.number,
    isSwiping: PropTypes.bool,
    isToRight: PropTypes.bool,
    isNegative: PropTypes.bool,
    isNeutral: PropTypes.bool,
    isToTop: PropTypes.bool,
    isToLeft: PropTypes.bool,
    isPositive: PropTypes.bool,
    backSwipe: PropTypes.func,
    positiveSwipe: PropTypes.func,
    neutralSwipe: PropTypes.func,
    negativeSwipe: PropTypes.func,
    isAnsweredCardsExist: PropTypes.func,
    forwardSwipe: PropTypes.func,
    card: PropTypes.oneOfType([models.gameCard, models.compromiseGameCard]),
    completedCards: PropTypes.array,
  };

  const { currentLocationIs } = useCurrentLocation();
  return (
    <div className="in-game-page__main__swipe-wrapper__wrapper__actions">
      <BaseGameActionButton
        className="in-game-page__main__swipe-wrapper__wrapper__actions__action"
        disabled={countCard <= 0 || isSwiping}
        onClick={backSwipe}
        type="back"
      />
      <BaseGameActionButton
        className={`in-game-page__main__swipe-wrapper__wrapper__actions__action`}
        disabled={isToRight || isToTop || isPositive || isNeutral}
        onClick={negativeSwipe}
        isNegative={isToLeft}
        type="negative"
        prevAnswer={completedCards[countCard]?.answer}
      />
      <BaseGameActionButton
        className={`in-game-page__main__swipe-wrapper__wrapper__actions__action`}
        disabled={isToLeft || isToRight || isPositive || isNegative}
        onClick={neutralSwipe}
        isNeutral={isToTop}
        type="question"
        prevAnswer={completedCards[countCard]?.answer}
      />
      <BaseGameActionButton
        className={`in-game-page__main__swipe-wrapper__wrapper__actions__action`}
        disabled={isToLeft || isNegative || isNeutral || isToTop}
        onClick={positiveSwipe}
        isPositive={isToRight}
        type="positive"
        prevAnswer={completedCards[countCard]?.answer}
      />
      <BaseGameActionButton
        className="in-game-page__main__swipe-wrapper__wrapper__actions__action"
        disabled={
          isAnsweredCardsExist(card) || isSwiping || !completedCards.length
        }
        onClick={forwardSwipe}
        type="forward"
      />
    </div>
  );
});
